import posts from '../pages/blog/posts.json';

export const getPosts = () => posts;

export const getPostBySlug = (slug) => {
    const posts = getPosts();
    return posts.find((post) => post.slug === slug);
};
